import { Controller } from "@hotwired/stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["entries", "pagination", "bottom"];

  initialize() {
    const options = {
      rootMargin: "200px"
    };

    this.intersectionObserver = new IntersectionObserver(
      (entries) => this.processIntersectionEntries(entries),
      options
    );
  }

  connect() {
    this.intersectionObserver.observe(this.bottomTarget);
  }

  disconnect() {
    this.intersectionObserver.unobserve(this.bottomTarget);
  }

  bottomTargetConnected() {
    this.intersectionObserver.unobserve(this.bottomTarget);
    this.intersectionObserver.observe(this.bottomTarget);
  }

  processIntersectionEntries(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.loadMore();
      }
    });
  }

  loadMore() {
    const nextPage = this.paginationTarget.querySelector("a[rel='next']");
    if (nextPage == null) {
      return;
    }
    const url = nextPage.href;

    Rails.ajax({
      type: "GET",
      url: url,
      dataType: "json",
      success: (data) => {
        this.bottomTarget.insertAdjacentHTML("beforebegin", data.entries);
        this.paginationTarget.innerHTML = data.pagination;
      }
    });
  }
}
